import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"
import { APP_ROUTES } from "~/shared/constants/routes"

const SettingsPage = loadable(async () => import("~/features/driver-document-expiry/pages/DriverDocumentExpirySettingsPage"), { fallback: <></> })
export const driverDocumentExpiryRoutes: RouteObject[] = [{ path: APP_ROUTES.driverDocumentExpirySettings, element: <SettingsPage /> }]
